var map = {
	"./Auto spares.jpg": 332,
	"./Books store.jpg": 333,
	"./Clothes - Girls.jpg": 334,
	"./Clothes- Kids.jpg": 335,
	"./Clothes-Ladies.jpg": 336,
	"./Construction material.jpg": 337,
	"./Dress - Mens.jpg": 338,
	"./Electronics.jpg": 339,
	"./Furnitues.jpg": 340,
	"./Grocery.jpg": 341,
	"./Home improvements.jpg": 342,
	"./Hotel.jpg": 343,
	"./Jewellery shop.jpg": 344,
	"./Kids toys.jpg": 345,
	"./Make up.jpg": 346,
	"./Mobiles.jpg": 347,
	"./Pharmacy-2.jpg": 348,
	"./Pharmacy.jpg": 349,
	"./Restaurant-3.jpg": 350,
	"./Restaurant.jpg": 351,
	"./Sales Rush.jpg": 352,
	"./Shoes- Ladies.jpg": 353,
	"./Sports shop...jpg": 354,
	"./Super market.jpg": 355,
	"./Travel Agency.jpg": 356,
	"./architecture-5999913_640.jpg": 357,
	"./baby products.2.jpg": 358,
	"./cloth shop.jpg": 359,
	"./electronics 2.jpg": 360,
	"./restaurant-2.jpg": 361,
	"./super market 2.jpg": 362,
	"./truck-1030846_640.jpg": 363
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 331;